import axios from 'axios';
import { ROOT_URL } from '../constants/Config';
import * as types from 'constants/ActionTypes.js';

export function getBanner() {
  return dispatch => {
    try {
      return axios.get(`${ROOT_URL}/banner/get`).then(({ data: { data } }) => {
        dispatch({ type: types.SET_BANNER, payload: data });
        return data;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: types.SET_BANNER, payload: [] });
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/banner.js